
import { of as observableOf, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable, Type } from '@angular/core';
import { environment } from '@environments/environment';;
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { ICustomFieldTemplateResponse } from './customfieldtemplate.model';
import { ActivityFilter, IActivityLogs } from '../library-service/library-model';

@Injectable({ providedIn: 'root' })
export class CustomFieldTemplatesService {
    constructor(private http: HttpClient) { }
    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}${CustomFieldTemplatesService.ENDPOINT}`; }
    private static readonly ENDPOINT = 'customfieldtemplates';

    public getCustomFieldTempates(body: any): Observable<SuccessResponse<ICustomFieldTemplateResponse> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<ICustomFieldTemplateResponse>>(CustomFieldTemplatesService.URL + '/filters', body).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updateCustomFieldTempate(id: string, body: any): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(CustomFieldTemplatesService.URL + '/' + id, body).pipe(
                catchError(error => observableOf(error.error)));
    }

    public addCustomFieldTempate(body: any): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(CustomFieldTemplatesService.URL, body).pipe(
                catchError(error =>{
                   return  observableOf(error.error);}
                ));
    }


    public cloneCustomFieldTempate(id: string, body: any): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(CustomFieldTemplatesService.URL + '/' + id + '/clones', body).pipe(
                catchError(error => observableOf(error.error)));
    }

    public getCustomFieldTempateActivities(filter: ActivityFilter): Observable<SuccessResponse<IActivityLogs> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IActivityLogs>>(CustomFieldTemplatesService.URL + '/activities', filter).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public deleteCustomFieldTempate(id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .delete<SuccessResponse<boolean>>(CustomFieldTemplatesService.URL + '/' + id).pipe(
                catchError(error => observableOf(error.error)));
    }

    public getCustomFieldTempate(id: string): Observable<SuccessResponse<ICustomFieldTemplateResponse> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<ICustomFieldTemplateResponse>>(CustomFieldTemplatesService.URL + '/' + id).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getCustomFieldTempateDropdowns(): Observable<SuccessResponse<ICustomFieldTemplateResponse> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<ICustomFieldTemplateResponse>>(CustomFieldTemplatesService.URL + '/dropdowns').pipe(
                catchError(error => observableOf(new ErrorResponse(error.error))));
    }

}
